export const ANALYTICS_GROUP = {
  DATA_ENTITIES: "data_entities"
} as const

export type AnalyticsGroupKey =
  (typeof ANALYTICS_GROUP)[keyof typeof ANALYTICS_GROUP]

export type AnalyticsEventsType = {
  [K in AnalyticsGroupKey]: Record<string, string>
}

export const ANALYTICS_EVENTS: AnalyticsEventsType = {
  data_entities: {
    ENTITY_EXPAND_PARAGRAPH: "entity_expand_paragraph",
    ENTITY_COPY_PARAGRAPH: "entity_copy_paragraph",
    ENTITY_GOTO_SECTION: "entity_goto_section",
    ENTITY_EXPORT_DATA: "entity_export_data",
    ENTITY_ABANDON_EXPORT_DATA: "entity_abandon_export_data",
    DATABASE_SHOW_OR_HIDE_SUMMARY: "database_show_or_hide_summary",
    DATABASE_UPDATE_SCREENER: "database_update_screener",
    DATABASE_CANCEL_SCREEN: "database_cancel_screen",
    DATABASE_SCREEN_RECORDS: "database_screen_records",
    DATABASE_SELECT_TAB: "database_select_tab",
    DATABASE_SELECT_COLUMNS: "database_select_columns",
    DATABASE_APPLY_SELECT_COLUMNS: "database_apply_select_columns",
    DATABASE_UPDATE_LIMIT: "database_update_limit",
    DATABASE_UPDATE_PAGE: "database_update_page",
    DATABASE_ABANDON_EXPORT_RECORDS: "database_abandon_export_records",
    DATABASE_EXPORT_DATA: "database_export_data",
    DATABASE_PIVOT_DATA: "database_pivot_data",
    DATABASE_EXPORT_PIVOT_DATA: "database_export_pivot_data"
  }
}
